import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { initAnalytics } from "@/lib/analytics/mixpanel";
import { validatePlansIntegrity } from "@/config/plans";
import { initPerfProbe } from "@/lib/perfProbe";

initPerfProbe();

// Runtime integrity check — catches config drift before users hit it
const { valid, errors } = validatePlansIntegrity();
if (!valid) {
  console.error('[PLANS INTEGRITY FAILURE]', errors);
}

initAnalytics();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
